import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/parent-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/parent-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/parent-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = ({ id, data }) => {
  return httpClient
    .put(`/api/parent-profiles/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/parent-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const notionality = (Options = {}) => {
  return httpClient
    .get('/api/parent-profiles/nationalities')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const occupation = (Options = {}) => {
  return httpClient
    .get(
      '/api/occupations?fields[setup_occupations]=occupation_id,occupation_name_en&page=-1'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const province = (Options = {}) => {
  return httpClient
    .get('/api/parent-profiles/provinces')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const district = (province_code, Options = {}) => {
  return httpClient
    .get(`/api/parent-profiles/district/${province_code}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const commune = (district_code, Options = {}) => {
  return httpClient
    .get(`/api/parent-profiles/communes/${district_code}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const village = (commune_code, Options = {}) => {
  return httpClient
    .get(`/api/parent-profiles/villages/${commune_code}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadPhoto = data => {
  return httpClient
    .post('/api/parent-profiles/upload-photoes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const notificationType = (Options = {}) => {
  return httpClient
    .get('/api/parent-profiles/notification-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const agreement = (Options = {}) => {
  return httpClient
    .get('/api/parent-profiles/agreements')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const children = data => {
  return httpClient
    .post('/api/parent-profiles/childrens', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const privacy = data => {
  return httpClient
    .post('/api/parent-profiles/privacy-notifications', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const saveAgreement = data => {
  return httpClient
    .post('/api/parent-profiles/agreements', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const generateCard = data => {
  return httpClient
    .post('/api/parent-profiles/generate-pickups', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const requestValidateFather = data => {
  return httpClient
    .post('/api/parent-profiles/request-validate-father', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const requestValidateMother = data => {
  return httpClient
    .post('/api/parent-profiles/request-validate-mother', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const branchStudent = data => {
  return httpClient
    .get('/api/parent-profiles/branchs', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const createOccupation = data => {
  return httpClient
    .post('/api/parent-profiles/occupations/create', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  notionality,
  occupation,
  province,
  district,
  commune,
  village,
  uploadPhoto,
  notificationType,
  agreement,
  children,
  privacy,
  saveAgreement,
  generateCard,
  requestValidateFather,
  requestValidateMother,
  branchStudent,
  createOccupation
}
